import { UPDATE_MESSAGE_LIST, SEARCH_MESSAGES_DATABASE } from '../../actions/types';

const initState = {
  messages: [],
  searchedMessages: []
};


export default function messagesReducer(state=initState, action) {
  switch (action.type) {
    case UPDATE_MESSAGE_LIST:
      return {
        ...state,
        messages: action.payload
      };
    case SEARCH_MESSAGES_DATABASE:
      return {
        ...state,
        searchedMessages: action.payload
      }
    default:
      return state;
  }
}


/* END */



// WEBPACK FOOTER //
// ./src/reducers/alerts/messages_reducer.js